import React from 'react';

const Image = ({ src, src2, alt }) => {
	const srcSet = src2 ? src + ', ' + src2 + ' 2x' : src;
	return <img src={src} srcSet={srcSet} alt={alt ? alt : ''} />;
};

export default Image;
